import { render, staticRenderFns } from "./settingAddEditPayment.vue?vue&type=template&id=d7c5245e&scoped=true&"
import script from "./settingAddEditPayment.vue?vue&type=script&lang=js&"
export * from "./settingAddEditPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c5245e",
  null
  
)

export default component.exports